// extracted by mini-css-extract-plugin
export default {"expired":"expiredheader_expired__-jdRr"};